export default __webpack_public_path__ + "static/automotive6-b2ae4556d729d1c4aaa58e385e8bcfb4.jpeg";